<section class="pb-7">
  @if (filters(); as filters) {
    <div class="desk:centered-with-padding no-scrollbar flex w-screen overflow-x-auto px-5 pb-7">
      <app-filter-toggle-group [filters]="filters" [filterName]="filterName" />
    </div>
  }
  @if (handles(); as handles) {
    <div class="centered-with-padding grid grid-cols-1 gap-y-6 desk:grid-cols-4 desk:gap-5">
      @for (handle of handles; track handleIndex; let handleIndex = $index) {
        <div class="h-[276px]">
          @let style = handle.styles[currentIndices()[handleIndex]!]!;
          <app-option-card
            [image]="style.image"
            (imageClicked)="openVisualFullScreenModal(style.image)"
            imageCursorType="zoomIn">
            <div card-title-left>{{ handle.title }}</div>
            <div card-title-right class="flex gap-x-2.5">
              @for (styleIndex of handle.styles.length | generateRange; track styleIndex) {
                @let style = handle.styles[styleIndex]!;
                @let isSelected = styleIndex === currentIndices()[handleIndex];
                <button
                  [title]="style.color.name"
                  (click)="updateIndex(handleIndex, styleIndex)"
                  [class.outline]="isSelected"
                  [class.outline-offset-2]="isSelected"
                  [class.outline-2]="isSelected"
                  [class.outline-black]="isSelected"
                  [ngStyle]="{ backgroundColor: `rgb(${style.color.rgb})` }"
                  class="size-5 rounded-md"></button>
              }
            </div>
          </app-option-card>
        </div>
      }
    </div>
  } @else {
    <app-grid-skeleton
      gridClass="centered-with-padding grid grid-cols-1 gap-y-6 desk:grid-cols-4 desk:gap-5"
      itemClass="h-[276px]"
      [count]="8" />
  }
</section>
